import { render, staticRenderFns } from "./SapDeliveryForm.vue?vue&type=template&id=36c47a66&scoped=true&"
import script from "./SapDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./SapDeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./SapDeliveryForm.vue?vue&type=style&index=0&id=36c47a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c47a66",
  null
  
)

export default component.exports